import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { StorytellerState } from 'store/StorytellerReduxState';
import Actions from 'Actions';

interface Format {
  id: string;
  tag: string | null;
  name: string;
  dropdown: boolean;
  group?: number;
  panel?: boolean;
  color?: string;
}

export interface RichTextEditorState {
  activeFormats: Format[];
}

const initialState: RichTextEditorState = {
  activeFormats: [],
};

/* Action Creators */
export const updateRTEActiveFormats = createAction(
  Actions.RTE_TOOLBAR_UPDATE_ACTIVE_FORMATS,
  (activeFormats: Format[]) => ({
    payload: { activeFormats },
  }),
);

export const richTextEditorReducer = createReducer(initialState, (builder) => {
  builder.addCase(updateRTEActiveFormats, (state, action) => {
    state.activeFormats = action.payload.activeFormats;
  });
});

/* Selectors */
export const selectRichTextEditorSlice = (state: StorytellerState) => state.richTextEditor;

export const selectRTEActiveFormats = createSelector(
  selectRichTextEditorSlice,
  (richTextEditor) => richTextEditor.activeFormats,
);
